export default __webpack_public_path__ + "static/media/Privacy policy.9854a808.pdf";